import type { ComponentStyleConfig } from "@chakra-ui/react";

export const TableTheme: ComponentStyleConfig = {
  variants: {
    basic: {
      thead: {
        tr: {
          th: {
            fontWeight: "black",
            py: 2,
            px: 2,
            "&.current": {
              pos: "relative",
              bg: "brand.gray.110",
              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "100%",
                bg: "inherit",
                height: "0.5rem",
                borderRadius: "5px 5px 0 0",
                left: 0,
                top: "-0.5rem",
              },
            },
            "&.highlighted": {
              pos: "relative",
              bg: "brand.skyblue.10",
              border: "1px solid",
              borderColor: "brand.skyblue.100",
              borderBottom: "none",
              borderTop: "none",
              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "calc(100% + 2px)",
                height: "0.5rem",
                borderRadius: "5px 5px 0 0",
                border: "1px solid",
                borderColor: "brand.skyblue.100",
                borderBottom: "none",
                left: "-1px",
                top: "-0.5rem",
              },
            },
          },
        },
      },
      tbody: {
        tr: {
          fontSize: "sm",
          td: {
            borderBottom: "1px solid",
            borderColor: "brand.gray.110",
            py: 2,
            px: 2,
            "&.current": {
              bg: "brand.gray.110",
            },
            "&.highlighted": {
              bg: "brand.skyblue.10",
              border: "1px solid",
              borderColor: "brand.skyblue.100",
              borderTop: "none",
              borderBottomColor: "brand.gray.110",
            },
          },
          "&:last-of-type": {
            "td.current": {
              pos: "relative",
              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "100%",
                bg: "inherit",
                height: "0.5rem",
                borderRadius: "0 0 5px 5px",
                left: 0,
                bottom: "-8px",
              },
            },
            "td.highlighted": {
              pos: "relative",
              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "calc(100% + 2px)",
                height: "0.5rem",
                borderRadius: "0 0 5px 5px",
                border: "1px solid",
                borderColor: "brand.skyblue.100",
                borderTop: "none",
                left: "-1px",
                bottom: "-8px",
              },
            },
          },
        },
      },
    },
    compare: {
      table: {
        borderSpacing: "2rem 0",
        borderCollapse: "separate",
        w: "auto",
        my: 3,
        "&.open": {
          "th:first-of-type": {
            cursor: "pointer",
          },
        },
        "&.closed": {
          tbody: {
            display: "none",
          },
          tfoot: {
            display: "none",
          },
          th: {
            cursor: "pointer",
            "&:not(:first-of-type)": {
              cursor: "default",
              _before: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "100%",
                bg: "inherit",
                height: "0.5rem",
                borderRadius: "0 0 5px 5px",
                boxShadow: "md",
                left: 0,
                bottom: "-8px",
              },
              "&:nth-of-type(2)": {
                // current
                _before: {
                  boxShadow: "none",
                },
              },
            },
          },
        },
      },
      thead: {
        tr: {
          th: {
            fontWeight: "black",
            textTransform: "none",
            letterSpacing: "normal",
            width: "400px",
            py: 2,
            px: 2,
            bg: "white",
            "&:first-of-type": {
              bg: "transparent",
              width: "300px",
              maxWidth: "300px",
            },
            "&:not(:first-of-type)": {
              pos: "relative",
              textAlign: "center",
              fontSize: "16px",
              color: "brand.gray.120",
              bg: "white",
              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "100%",
                bg: "inherit",
                height: "0.5rem",
                borderRadius: "5px 5px 0 0",
                left: 0,
                top: "-0.5rem",
              },
              "&:nth-of-type(2)": {
                // current
                bg: "transparent",
              },
            },
          },
        },
      },
      tbody: {
        tr: {
          pos: "relative",
          "&:not(.prevent-hover):hover": {
            _after: {
              display: "block",
              content: '""',
              pos: "absolute",
              width: "calc(100% - 2rem)",
              height: "100%",
              top: 0,
              left: 0,
              bg: "brand.skyblue.10",
              borderRadius: 4,
              pointerEvents: "none",
            },
          },
          "&.highlight": {
            _after: {
              display: "block",
              content: '""',
              pos: "absolute",
              width: "calc(100% - 2rem)",
              height: "100%",
              top: 0,
              left: 0,
              bg: "brand.skyblue.10",
              borderRadius: 4,
            },
          },
          td: {
            width: "400px",
            px: 2,
            py: 0,
            bg: "white",
            "&:first-of-type": {
              width: "300px",
              maxWidth: "300px",
              bg: "transparent",
              py: 2,
            },
            "&:nth-of-type(2)": {
              // current
              bg: "transparent",
              _after: {
                bg: "transparent",
              },
            },
          },
          "&:last-child": {
            "td:not(:first-of-type)": {
              pos: "relative",
              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "100%",
                bg: "inherit",
                height: "0.5rem",
                borderRadius: "0 0 5px 5px",
                boxShadow: "md",
                left: 0,
                bottom: "-8px",
              },
              "&:nth-of-type(2)": {
                // current
                bg: "transparent",
                _after: {
                  bg: "transparent",
                  boxShadow: "none",
                },
              },
            },
          },
        },
      },
      tfoot: {
        tr: {
          pos: "relative",
          td: {
            width: "400px",
            px: 2,
            py: 2,
            bg: "white",
            "&:first-of-type": {
              width: "300px",
              maxWidth: "300px",
              bg: "transparent",
              py: 2,
            },
            "&:nth-of-type(2)": {
              // current
              bg: "transparent",
            },
          },
          "&:last-child": {
            "td:not(:first-of-type)": {
              pos: "relative",
              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "100%",
                bg: "inherit",
                height: "0.5rem",
                borderRadius: "0 0 5px 5px",
                boxShadow: "md",
                left: 0,
                bottom: "-8px",
              },
              "&:nth-of-type(2)": {
                // current
                bg: "transparent",
                _after: {
                  boxShadow: "none",
                },
              },
            },
          },
        },
      },
    },
  },
};
